// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // SENDGRID_API_KEY: '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'
  SENDGRID_API_KEY: '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'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
